import React, { useState } from 'react';
import { compose } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';

import CompareExperimentsModal from './compareExperimentsModal';
import FiltersResult from './filtersResult';
import FiltersForm from './filtersForm';
import HistogramModal from './histogramModal';
import useLocalStorage from '../hooks/useLocalStorage';
import { ErrorBoundary } from '../../main/hoc/errorboundary';
import { clearSelected } from '../actions/experimentsList';


const Filters = ({ variables, defaultFormControls }) => {
  const [ openCompareShotsModal, setOpenCompareShotsModal ] = useState(false);

  const [ histogramModal, setHistogramModal ] = useState({
    isOpen: false,
    idsField: '',
    variable_id: 0,
    machines: [],
    variableName: '',
    unit: '',
    min: 0,
    max: 0
  });
  const [ initialFiltersValues, setInitialFiltersValues ] = useState({});

  const [ formControls, setFormControls ] = useLocalStorage('formControls', defaultFormControls);

  const results = useSelector((state) => state.experiments.get('pagination').get('totalElements'));
  const selectedExperiments = useSelector((state) => state.experiments.get('selectedExperiments'));
  
  const toggleCompareShotsModal = () => setOpenCompareShotsModal((prev) => !prev);

  const dispatch = useDispatch();

  const clearSelectedExperiments = () => dispatch(clearSelected());
  
  const onOpenHistogramModal = (idsField, variable_id, machines, variableName, unit, min, max) => {
    setHistogramModal({
      isOpen: true,
      idsField,
      variable_id,
      machines,
      variableName,
      unit,
      min,
      max
    });
    setInitialFiltersValues({});
  };

  const onCloseHistogramModal = (variable_id, min, max) => {
    setHistogramModal(prev => ({ ...prev, isOpen: false }));

    if (min || max) {
      setInitialFiltersValues({
        [`${variable_id}_min`]: min,
        [`${variable_id}_max`]: max
      });
    }
  };

  return (
    <Container>
      <CompareExperimentsModal isOpen={openCompareShotsModal} toggle={toggleCompareShotsModal} variablesNames={variables}/>
      {histogramModal.isOpen && (
        <HistogramModal 
          isOpen={histogramModal.isOpen} 
          idsField={histogramModal.idsField}
          variable_id={histogramModal.variable_id}
          machines={histogramModal.machines}
          variableName={histogramModal.variableName}
          unit={histogramModal.unit}
          initialMinValue={histogramModal.min}
          initialMaxValue={histogramModal.max} 
          onCloseHistogramModal={onCloseHistogramModal}
        />
      )}
      <Row>
        <FiltersForm 
          onOpenHistogramModal={onOpenHistogramModal}
          initialFiltersValues={initialFiltersValues} 
          setFormControls={setFormControls}
          formControls={formControls}
          defaultFormControls={defaultFormControls}
          variables={variables}
        />
      </Row>
      <Row className={"mt-3 mb-4"}>
        <Col>
          <FiltersResult 
            allExperimentsCount={results} 
            selectedExperiments={selectedExperiments}
            formControls={formControls}
            toggleCompareShotsModal={toggleCompareShotsModal}
            allVariables={variables}
            clearSelectedPulses={clearSelectedExperiments}
          />

        </Col>
      </Row>
    </Container>
  );
};

Filters.propTypes = {
  variables: PropTypes.object.isRequired,
  defaultFormControls: PropTypes.array.isRequired
};

export default compose(
  ErrorBoundary((props) => props.t('components.filters'))
)(Filters);